import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { LOGIN_PATH } from '@/lib/api';

export default function ProtectedRoute({ children, requireRole = 'admin' }) {
  const { user, bootstrapped } = useAuth();
  const location = useLocation();

  const navState = useMemo(() => ({ from: location }), [location]);

  // While auth is still being validated, show a lightweight skeleton.
  if (!bootstrapped && !user) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
        Verifying session...
      </div>
    );
  }

  if (!user) {
    return <Navigate to={LOGIN_PATH} replace state={navState} />;
  }
  if (requireRole && user.role !== requireRole) {
    return <Navigate to={LOGIN_PATH} replace />;
  }
  return children;
}
